import React, { useState, useEffect } from 'react';
import { generate } from 'shortid';
import classnames from "classnames";
import { createStyles, withStyles } from '@material-ui/core/styles';
import {
  Dialog, DialogContent, DialogActions,
  Slide, DialogTitle
} from '@material-ui/core';
import SqureButton from 'Components/Common/SqureButton';
import CommonCss from 'commonCss';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => createStyles({
  formControl: {
    ...CommonCss.formControl,
    '& > div': {
      backgroundColor: 'tarsparent !important',
      border: 'none',
      paddingRight: 0,
    },
    padding: '.375rem',
  },
  formGroup: {
    marginTop: 5,
    marginBottom: 16,
    '& input': {
      color: '#6C6C6C !important'
    }
  },
  dialogContent: {
    minHeight: 170,
    overflowY: 'hidden',
    "& [class*=select__menu]": {
      maxHeight: 100
    }
  },
});

const AddTabDialog = ({
  classes,
  isOpen,
  onSubmit,
  onClose,
  data,
}) => {
  const [name, setName] = useState("");
  const [isNew, setType] = useState(true);
  
  const handleOnClose = () => {
    setName("")
    onClose()
  }

  useEffect(() => {
    if(data !== null){
      setName(data?.Name || "");
      setType(false);
    }
  }, [data])

  return (
    <Dialog
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleOnClose()
        }
      }}
      aria-labelledby=""
      open={isOpen}
      TransitionComponent={Transition}
      scroll={"body"}
      fullWidth={true}
      className={classnames(classes.dialog)}
      id={`addTabDialog${generate()}`}
      style={{ zIndex: 10001 }}
    >
      <DialogTitle id={`form-dialog-title${generate()}`}>
        {isNew ? 'Create New Tab' : 'Update Tab'}
      </DialogTitle>
      <DialogContent>
        <div className={classes.formGroup}>
          <label>Name</label>
          <input
            className={classes.formControl}
            value={name}
            placeholder="Enter Tab Name"
            onChange={(e) => setName(e.target?.value)}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <div style={{ padding: '10px 24px' }}>
          <SqureButton
            variant={"outlined"}
            onClick={() => {
              handleOnClose()
            }}
          >
            Cancel
          </SqureButton>
          &nbsp; &nbsp; &nbsp;
          <SqureButton
            variant={"contained"}
            disabled={name.length === 0}
            onClick={() => {
              onSubmit({
                name
              })
              handleOnClose()
            }}
          >
            Save
          </SqureButton>
        </div>
      </DialogActions>
    </Dialog >
  )
}


export default React.memo(withStyles(styles)(AddTabDialog));
